<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <card-component titulo="Lista dos fornecedores" componente="null" usuario="null">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col mb-3">
                                <input-container-component titulo="Nome" id="inputNome">
                                    <input type="text" class="form-control" id="inputNome" placeholder="Informe o Nome"
                                        v-model="busca.razao_social" @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                        </div>
                        <table-component :dados="fornecedores.data" componentpai="fornecedor" :editar="{ 
                            visivel: true,
                            dataToggle: 'modal',
                            dataTarget: '#modalFornecedorAtualizar'
                        }" :remover="{
                            visivel: false,
                            dataToggle: 'modal',
                            dataTarget: '#modalFornecedorRemover'
                        }" :titulos="{
                            id: { titulo: '', tipo: '' },
                            razao_social: { titulo: 'Razão Social', tipo: 'texto' },
                        }"></table-component>
                    </template>
                    <template v-slot:rodape>
                        <div class="row">
                            <div class="col-10">
                                <paginate-component>
                                    <li v-for="l, key in fornecedores.links" :key="key"
                                        :class="l.active ? 'page-item active' : 'page-item'"><a class="page-link"
                                            v-html="l.label" @click="paginacao(l)"></a></li>
                                </paginate-component>
                            </div>
                            <div class="col-2">
                                <button type="button" class="btn btn-primary btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalfornecedor">
                                    Adicionar
                                </button>
                            </div>
                        </div>
                    </template>
                </card-component>
            </div>
        </div>
        <modal-component id="modalfornecedor" titulo="Adicionar Fornecedor">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="transacaoDetalhes" titulo="Cadastro realizado com sucesso!"
                    v-if="transacaoStatus == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="transacaoDetalhes" titulo="Erro ao cadastrar."
                    v-if="transacaoStatus == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Razão Social" id="novoFornecedor">
                        <input type="text" class="form-control" id="novoFornecedor" placeholder="Informe a Razão Social"
                            v-model="razaoSocial">
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="salvar()">Salvar</button>
            </template>
        </modal-component>

        <modal-component id="modalFornecedorAtualizar" titulo="Atualizar Fornecedor">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Fornecedor atualizado com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao atualizar."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Razão Social Fornecedor" id="atualizarFornecedor">
                        <input type="text" class="form-control" id="atualizarFornecedor"
                            placeholder="Informe a Razão Social Fornecedor" v-model="$store.state.item.razao_social">
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="atualizarFornecedor()">Atualizar</button>
            </template>
        </modal-component>

        <modal-component id="modalFornecedorRemover" titulo="Remover Fornecedor">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Fornecedor removido com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao remover."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo v-if="$store.state.transacao.status != 'sucesso'">
                <div class="form-group">
                    <input-container-component titulo="Razão Social Fornecedor" id="removeFornecedor">
                        <input type="text" class="form-control" id="removeFornecedor"
                            placeholder="Informe a Razão Social Fornecedor" v-model="$store.state.item.razao_social" disabled>
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-danger" @click="removerFornecedor()"
                    v-if="$store.state.transacao.status != 'sucesso'">Remover</button>
            </template>
        </modal-component>
    </div>
</template>

<script>
export default {
    props: ['user'], 
    data() {
        return {
            urlBase: 'https://contasmoradores.candido.org.br/api/v1/fornecedor',
            urlPaginacao: '',
            urlFiltro: '',
            fornecedores: { data: [] },
            razaoSocial: '',
            transacaoStatus: '',
            transacaoDetalhes: {},
            busca: { razao_social: '' },
            links: {}
        }
    },
    methods: {
        resetTransacao() {
            this.transacaoStatus = ''
            this.transacaoDetalhes = ''
            this.razaoSocial = ''
        },
        atualizarFornecedor() {
            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('razao_social', this.$store.state.item.razao_social)
            formData.append('caps_id', this.$store.state.item.caps_id)


            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        removerFornecedor() {
            let confirmacao = confirm('Confirmar remoção do registro!')

            if (!confirmacao) return false

            let formData = new FormData()
            formData.append('_method', 'delete')

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        pesquisar() {
            let filtro = ''
            for (let chave in this.busca) {
                if (this.busca[chave]) {
                    if (filtro != '') {
                        filtro += ';'
                    }
                    filtro += chave + ':like:' + this.busca[chave]
                }
            }
            if (filtro != '') {
                this.urlPaginacao = 'page=1'
                this.urlFiltro = ';' + filtro + '%' 
            } else {
                this.urlFiltro = ''
            }
            this.carregarLista()
        },
        paginacao(l) {
            if (l.url) {
                this.urlPaginacao = l.url.split('?')[1]
                this.carregarLista()
            }
        },
        carregarLista() {
            let url = ''
            if(this.userJson.nivel_acesso != 'adm') {
                url = this.urlBase + '?' + this.urlPaginacao + '&filtro=caps_id:=:' + this.userJson.caps_id + this.urlFiltro    
            } else [
                url = this.urlBase + '?' + this.urlPaginacao + this.urlFiltro
            ]
            
            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.fornecedores = response.data 
                })
                .catch(errors => {
                })
        },
        salvar() {
            console.log(this.userJson.caps_id)
            let formData = new FormData()

            formData.append('razao_social', this.razaoSocial)
            formData.append('caps_id', this.userJson.caps_id)

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post(this.urlBase, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.transacaoStatus = 'sucesso'
                    this.transacaoDetalhes = {
                        mensagem: 'ID do registro: ' + response.data.id
                    }
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.transacaoStatus = 'erro'
                    this.transacaoDetalhes = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        }
    },
    mounted() {
        this.carregarLista()
        // Obtém o elemento da modal pelo ID
        const modalElement = document.getElementById('modalfornecedor');

        // Adiciona o evento de fechamento da modal para resetar as variáveis
        modalElement.addEventListener('hidden.bs.modal', this.resetTransacao);
    },
    beforeUnmount() {
        // Remove o evento ao desmontar o componente para evitar vazamento de memória
        const modalElement = document.getElementById('modalfornecedor');
        modalElement.removeEventListener('hidden.bs.modal', this.resetTransacao);
    },
    computed: {
        token() {
            let token = 'Bearer ' + document.cookie.split(';').find(indice => {
                return indice.includes('token=')
            }).split('=')[1]
            return token
        },

        userJson() {
            return JSON.parse(this.user);
        },
    },
}
</script>
